import { render, staticRenderFns } from "./appointSuccess.vue?vue&type=template&id=25c79914&scoped=true&"
import script from "./appointSuccess.vue?vue&type=script&lang=js&"
export * from "./appointSuccess.vue?vue&type=script&lang=js&"
import style0 from "./appointSuccess.vue?vue&type=style&index=0&id=25c79914&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c79914",
  null
  
)

export default component.exports